import { get } from 'lodash';
import k2aBaseApi from '../apis/key2act';

import { setBobLoading } from './bobActions';

import awsHeader from '../helpers/awsAuth';
import moment from 'moment';
import template from 'url-template';
import {
    FETCH_SCHEDULE_TECHNICIANS,
    FETCH_SCHEDULED_APPOINTMENTS,
    FETCH_UNSCHEDULED_APPOINTMENTS
} from './actionTypes';
import { handleNetworkError } from './applicationMessageActions';

const AppointmentsUrl = template.parse('/companies/{companyId}/appointments{?jobId,clientId,siteId,appointmentStatus,startDate,endDate}');
const TechniciansUrl = template.parse('/companies/{companyId}/users{?userType,activeState}');

export const fetchAppointments = (companyId, appointmentStatus, options = {}) => async dispatch => {
    const header = await awsHeader();

    try {
        const response = await k2aBaseApi.get(
            AppointmentsUrl.expand({
                companyId,
                appointmentStatus,
                ...options
            }),
            header
        );

        const appointmentsPayload = get(response, 'data.data', []);

        const payload = [...appointmentsPayload];

        payload.forEach(item => {
            item.startdatetime = new Date(item.startdatetime);
            item.enddatetime = item.estimateHours === 0 ? new Date(moment(item.startdatetime).add(1, 'h')) : new Date(moment(item.startdatetime).add(item.estimateHours, 'h'));
            item.technicianId = item.technicians ? item.technicians.userIds[0] : null;
        });

        switch (appointmentStatus) {
            case 0:
                dispatch({
                    type: FETCH_SCHEDULED_APPOINTMENTS,
                    payload
                });

                break;
            case 1:
                dispatch({
                    type: FETCH_UNSCHEDULED_APPOINTMENTS,
                    payload
                });

                break;
            default:
                break;
        }
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchScheduleTechnicians = (companyId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();
    options.userType = 0;
    options.activeState = 'Active';

    try {
        const response = await k2aBaseApi.get(
            TechniciansUrl.expand({
                companyId,
                ...options
            }),
            header
        );

        const payload = get(response, 'data.Data', []);

        payload.forEach(item => {
            item.id = item.Id;
            item.fullName = `${item.FirstName} ${item.LastName}`;
        });

        dispatch({
            type: FETCH_SCHEDULE_TECHNICIANS,
            payload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const updateAppointment = (companyId, appointment, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        dispatch(setBobLoading('UpdateAppointment'));
        const body = appointment;

        await k2aBaseApi.put(
            AppointmentsUrl.expand({
                companyId,
                ...options
            }),
            body,
            header
        );

        dispatch(setBobLoading('UpdateAppointment'));
        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));
        dispatch(setBobLoading('UpdateAppointment'));
        return false;
    }
};
